export default "__VITE_ASSET__DRoOo0ws__"